import { render, staticRenderFns } from "./RelatedListingItem.vue?vue&type=template&id=a618e65c&scoped=true&lang=pug"
import script from "./RelatedListingItem.vue?vue&type=script&lang=js"
export * from "./RelatedListingItem.vue?vue&type=script&lang=js"
import style0 from "./RelatedListingItem.vue?vue&type=style&index=0&id=a618e65c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a618e65c",
  null
  
)

export default component.exports